module.exports = __webpack_public_path__ + "static/media/home_catalogue.555d879c.png";